"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var svgs_1 = require("../assets/svgs");
var ThemedTextField = (0, system_1.styled)(material_1.TextField)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiOutlinedInput-root': {
            color: theme.palette.common.white,
            maxHeight: '4.8rem',
            backgroundColor: theme.palette.common[300],
            borderRadius: 9999,
            '& ::placeholder': {
                color: theme.palette.common[400],
            },
            '& fieldset': {
                borderWidth: 2,
            },
            '&:hover fieldset': {
                borderColor: theme.palette.primary.main,
            },
            '& input': {
                height: '2.4rem',
                paddingLeft: '0px !important',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
            },
        },
    });
});
var Search = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(ThemedTextField, __assign({}, props, { InputProps: {
            startAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, __assign({ position: "start", sx: {
                    marginRight: '1.7rem',
                } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.SearchSvg, {}) }))),
        } }, { children: children })));
};
exports.Search = Search;
